<template>
  <div id="course">
    <my-header activeIndex="课程平台" />
    <div class="banner"></div>
    <div class="wrapper">
      <div class="ai">
        <div class="title">
          <span>AI基础课程</span>
          <i>由广及深—让自动驾驶学会自主思考</i>
        </div>
        <ul class="content clearfix">
          <li
            v-for="(item, index) in aiList"
            :key="index"
            :class="`spe${index + 1}`"
            @mouseenter="item.isShow = true"
            @mouseleave="item.isShow = false"
          >
            <div
              :style="
                `background-image:url(${require(`../../assets/images/courseai${index +
                  1}.jpg`)});`
              "
            >
              <transition
                enter-active-class="animated slideInUp"
                leave-active-class="animated slideOutDown"
              >
                <p v-show="item.isShow">
                  <span>
                    <a :href="item.src" target="_blank">{{
                      item.details | lengthFilter(180)
                    }}</a>
                  </span>
                </p>
              </transition>
            </div>
            <a :href="item.src" target="_blank"
              >{{ item.name }}
              <span
                :class="{ active: item.ispay }"
                v-html="item.ispay ? '付费' : '免费'"
              >
              </span>
            </a>
          </li>
        </ul>
      </div>
      <div class="basics">
        <div class="title">
          <span>自动驾驶基础课程</span>
          <i>跬步之积—轻松入门自动驾驶</i>
        </div>
        <ul class="content clearfix">
          <li
            v-for="(item, index) in basicsList"
            :key="index"
            @mouseenter="item.isShow = true"
            @mouseleave="item.isShow = false"
          >
            <div
              :style="
                `background-image:url(${require(`../../assets/images/coursespecialty${index +
                  1}.jpg`)});`
              "
            >
              <transition
                enter-active-class="animated slideInUp"
                leave-active-class="animated slideOutDown"
              >
                <p v-show="item.isShow">
                  <span>
                    <a :href="item.src" target="_blank"
                      >{{ item.details | lengthFilter(110) }}
                    </a>
                  </span>
                </p>
              </transition>
            </div>
            <a :href="item.src" target="_blank">
              {{ item.name }}
              <span
                :class="{ active: item.ispay }"
                v-html="item.ispay ? '付费' : '免费'"
              >
              </span>
            </a>
          </li>
        </ul>
      </div>
      <div class="specialty">
        <div class="title">
          <span>自动驾驶专业课程</span>
          <i>更上层楼—踏上自动驾驶开发者之路</i>
        </div>
        <ul class="content clearfix">
          <li
            v-for="(item, index) in specialtyList"
            :key="index"
            @mouseenter="item.isShow = true"
            @mouseleave="item.isShow = false"
          >
            <div
              :style="
                `background-image:url(${require(`../../assets/images/coursebasics${index +
                  1}.jpg`)});`
              "
            >
              <transition
                enter-active-class="animated slideInUp"
                leave-active-class="animated slideOutDown"
              >
                <p v-show="item.isShow">
                  <span>
                    <a :href="item.src" target="_blank">{{
                      item.details | lengthFilter(110)
                    }}</a>
                  </span>
                </p>
              </transition>
            </div>
            <a :href="item.src" target="_blank"
              >{{ item.name }}
              <span
                :class="{ active: item.ispay }"
                v-html="item.ispay ? '付费' : '免费'"
              >
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <my-footer />
  </div>
</template>
<script>
import MyHeader from "@/components/header";
import MyFooter from "@/components/footer";
export default {
  name: "course",
  data() {
    return {
      aiList: [
        {
          name: "人工智能",
          details:
            "人工智能（Artificial Intelligence），英文缩写为AI。它是研究、开发用于模拟、延伸和扩展人的智能的理论、方法、技术及应用系统的一门新的技术科学。人工智能是计算机科学的一个分支，它企图了解智能的实质，并生产出一种新的能以人类智能相似的方式做出反应的智能机器，该领域的研究包括机器人、语言识别、图像识别、自然语言处理和专家系统等。",
          isShow: false,
          src: "http://www.xuetangx.com/courses/UC_BerkeleyX/CS188.1x/_/about"
        },
        {
          name: "机器学习",
          details:
            "机器学习是一门多领域交叉学科，涉及概率论、统计学、逼近论、凸分析、算法复杂度理论等多门学科。专门研究计算机怎样模拟或实现人类的学习行为，以获取新的知识或技能，重新组织已有的知识结构使之不断改善自身的性能。它是人工智能的核心，是使计算机具有智能的根本途径。",
          isShow: false,
          src: "https://www.coursera.org/learn/machine-learning/"
        },
        {
          name: "深度学习",
          details:
            "深度学习(DL, Deep Learning)是机器学习(ML, Machine Learning)领域中一个新的研究方向，它被引入机器学习使其更接近于最初的目标——人工智能(AI, Artificial Intelligence)。深度学习在搜索技术，数据挖掘，机器学习，语音，推荐和个性化技术，以及其他相关领域都取得了很多成果。",
          isShow: false,
          src:
            "https://www.icourse163.org/course/preview/HIT-1206320802?tid=1206635203"
        },
        {
          name: "计算机视觉",
          details:
            "计算机视觉是一门研究如何使机器“看”的科学，更进一步的说，就是是指用摄影机和电脑代替人眼对目标进行识别、跟踪和测量等机器视觉，并进一步做图形处理，使电脑处理成为更适合人眼观察或传送给仪器检测的图像。作为一个科学学科，计算机视觉研究相关的理论和技术，试图建立能够从图像或者多维数据中获取‘信息’的人工智能系统。这里所 指的信息指Shannon定义的，可以用来帮助做一个“决定”的信息。因为感知可以看作是从感官信号中提 取信息，所以计算机视觉也可以看作是研究如何使人工系统从图像或多维数据中“感知”的科学；",
          isShow: false,
          src: "https://www.coursera.org/specializations/computervision"
        },
        {
          name: "计算机SLAM",
          details:
            "SLAM (simultaneous localization and mapping), 即时定位与地图构建，被很多学者认为是实现真正全自主移动机器人的关键。SLAM指的是当某种设备（如机器人、VR设备等）来到一个完全陌生的环境时，它需要精准地建立时间和空间的对应关系，并能回答以下一系列问题：我刚才在哪里，现在在哪里？我看到了什么，现在看到的和之前看到的有哪些异同？我过去的行走轨迹是什么？我现在看到的世界是什么样子，和过去相比有怎样的变化？",
          isShow: false,
          ispay: true,
          src: "http://www.shenlanxueyuan.com/course/174?from=timeline"
        }
      ],
      basicsList: [
        {
          name: "现代控制理论",
          details:
            "《现代控制理论》课程是电气工程、自动化、信息技术等相关学科的专业基础课程。本课程的核心内容为控制系统的状态空间法和最优控制。本课程主要学习现代控制理论的建模、分析和综合的方法。通过《现代控制理论》课程的学习，不仅能够学习现代控制系统的基本理论及其应用方法。更重要的是能够学习用数学语言描述动态系统的方法，学习用数学工具分析改善动态系统性能的方法，从而培养用数学语言解决工程问题的能力。",
          isShow: false,
          src:
            "https://www.icourse163.org/course/preview/ZJU-1206497805/?tid=1206820209"
        },
        {
          name: "数值优化",
          details:
            "数值优化对于最优化问题提供了一种迭代算法思路，通过迭代逐渐接近最优解，分别对无约束最优化问题和带约束最优化问题进行求解。数值优化通过迭代的方式解决优化问题，是数学建模中关键的一环。Modeling过程，需要确定优化目标、目标所依赖的变量以及变量之间的约束关系，最后通过优化算法解决问题。",
          isShow: false,
          src: "https://www.kanbilibili.com/video/av10289610/"
        },
        {
          name: "机器人操作系统入口",
          details:
            "ROS是机器人操作系统（Robot Operating System）的英文缩写。ROS是用于编写机器人软件程序的一种具有高度灵活性的软件架构。它包含了大量工具软件、库代码和约定协议，旨在简化跨机器人平台创建复杂、鲁棒的机器人行为这一过程的难度与复杂度。ROS的原型源自斯坦福大学的STanford Artificial Intelligence Robot (STAIR) 和 Personal Robotics (PR)项目。",
          isShow: false,
          src: "https://www.icourse163.org/course/ISCAS-1002580008"
        },
        {
          name: "C++程序设计语言",
          details:
            "C++是C语言的继承，它既可以进行C语言的过程化程序设计，又可以进行以抽象数据类型为特点的基于对象的程序设计，还可以进行以继承和多态为特点的面向对象的程序设计。C++擅长面向对象程序设计的同时，还可以进行基于过程的程序设计，因而C++就适应的问题规模而论，大小由之。 C++不仅拥有计算机高效运行的实用性特征，同时还致力于提高大规模程序的编程质量与程序设计语言的问题描述能力。",
          isShow: false,
          src:
            "https://study.163.com/course/introduction/1005530011.htm?from=study"
        }
      ],
      specialtyList: [
        {
          name: "无人驾驶入门",
          details:
            "优达学城开发这门无人驾驶基础课程。基于Apollo 开放平台，帮助汽车行业及无人驾驶领域的合作伙伴结合车辆和硬件系统，快速搭建一套属于自己的无人驾驶系统。 你将在课程中跟随 Sebastian Thrun、David Silver 与 Apollo 专家团队，学习无人驾驶核心概念，掌握高精度地图、定位、感知、预测、规划与控制，接触前沿自动驾驶平台！",
          isShow: false,
          src:
            "https://cn.udacity.com/course/self-driving-car-fundamentals-featuring-apollo--ud0419"
        },
        {
          name: "无人驾驶入门九讲",
          details:
            "本课程详细讲解无人驾驶定位导航、感知、决策与控制等算法，深度学习在无人驾驶中的应用，无人驾驶系统软件和硬件平台，无人驾驶安全及无人驾驶云平台等多个主要技术点。课程首先会讲解到光学雷达、GPS及惯性传感器等应用，然后讲解AI领域的计算机视觉、卷积神经网络、增强学习在无人驾驶的应用，其次会讲解无人驾驶的规划与控制和ROS系统，最后讲解基于Spark与ROS的分布式无人驾驶模拟平台以及无人驾驶中的高精度地图等信息。",
          isShow: false,
          ispay: true,
          src: "https://edu.51cto.com/course/14591.html"
        },
        {
          name: "无人驾驶工程师",
          details:
            "无人驾驶车是现代历史中最具开创性的进步之一。它们带来的影响不仅仅在技术、交通或城市规划领域，而是深入到我们生活中的每一个方面，超乎你的想象。加入这个纳米学位项目，你将掌握那些能让你塑造未来的技术。你将参与一系列互动型实战项目，包括但不限于计算机视觉、机器人控制、定位和路线规划；你将会在这个激动人心的领域做好准备，大展身手。如果你想要塑造未来，那么就从这里开始吧！",
          isShow: false,
          src: "https://www.mooc.cn/course/8377.html"
        },
        {
          name: "无人驾驶实战",
          details:
            "无人驾驶汽车是智能汽车的一种，也称为轮式移动机器人，主要依靠车内的以计算机系统为主的智能驾驶仪来实现无人驾驶的目的。它是利用车载传感器来感知车辆周围环境，并根据感知所获得的道路、车辆位置和障碍物信息，控制车辆的转向和速度，从而使车辆能够安全、可靠地在道路上行驶。集自动控制、体系结构、人工智能、视觉计算等众多技术于一体，是计算机科学、模式识别和智能控制技术高度发展的产物，也是衡量一个国家科研实力和工业水平的一个重要标志，在国防和国民经济领域具有广阔的应用前景 。",
          isShow: false,
          ispay: true,
          src: "https://www.julyedu.com/course/getDetail/136"
        }
      ]
    };
  },
  components: { MyHeader, MyFooter }
};
</script>
<style lang="less">
#course {
  color: #333333;
  background: #f8fbff;
  .banner {
    width: 100%;
    padding-top: 24%;
    background: url("../../assets/images/coursebanner.jpg");
    background-size: 100% 100%;
  }
  .title {
    padding: 58px 0 38px;
    font-size: 26px;
    span {
      display: inline-block;
      line-height: 46px;
    }
    i {
      display: inline-block;
      padding-left: 33px;
      line-height: 46px;
      font-size: 18px;
      color: #666666;
    }
  }
  .ai {
    .content {
      li {
        float: left;
        width: 380px;
        margin-right: 20px;
        border-radius: 10px;
        > div {
          position: relative;
          height: 263px;
          background-size: 100% 100%;
          overflow: hidden;
          p {
            position: absolute;
            left: 0;
            bottom: 0;
            box-sizing: border-box;
            width: 100%;
            height: 253px;
            padding: 0 30px;
            line-height: 26px;
            font-size: 16px;
            text-align: justify;
            background: rgba(255, 255, 255, 0.9);
            span {
              display: table-cell;
              vertical-align: middle;
              height: 253px;
            }
          }
        }
        > a {
          display: block;
          height: 71px;
          padding: 0 15px;
          line-height: 71px;
          font-size: 20px;
          background: rgba(255, 255, 255, 0.9);
          span {
            float: right;
            height: 30px;
            padding: 0 10px;
            margin-top: 20px;
            line-height: 30px;
            font-size: 16px;
            color: #f8042c;
            &.active {
              border: 1px solid orange;
              color: orange;
            }
          }
        }
        &.spe1 {
          width: 720px;
          margin-right: 20px;
          margin-bottom: 20px;
          // p {
          //   color: #fff;
          //   background: transparent;
          // }
        }
        &.spe2 {
          width: 460px;
          margin-right: 0;
          margin-bottom: 20px;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .basics,
  .specialty {
    .content {
      li {
        float: left;
        width: 285px;
        margin-right: 20px;
        border-radius: 10px;
        > div {
          position: relative;
          height: 263px;
          background-size: 100% 100%;
          overflow: hidden;
          p {
            position: absolute;
            left: 0;
            bottom: 0;
            box-sizing: border-box;
            width: 100%;
            height: 253px;
            padding: 0 30px;
            line-height: 26px;
            font-size: 16px;
            text-align: justify;
            background: rgba(255, 255, 255, 0.9);
            span {
              display: table-cell;
              vertical-align: middle;
              height: 253px;
            }
          }
        }
        > a {
          display: block;
          height: 71px;
          padding: 0 15px;
          line-height: 71px;
          font-size: 20px;
          background: rgba(255, 255, 255, 0.9);
          span {
            float: right;
            height: 30px;
            padding: 0 10px;
            margin-top: 20px;
            line-height: 30px;
            font-size: 16px;
            color: #f8042c;
            &.active {
              border: 1px solid orange;
              color: orange;
            }
          }
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .specialty {
    padding-bottom: 100px;
  }
}
</style>
